/**
 * Magic-link login. Sends a sign-in email via Stytch.
 *
 * Returns a TanStack mutation, so the LoginPage gets `isPending` and
 * `error` for free without managing local state.
 *
 *   const login = useLogin();
 *   await login.mutateAsync(email);
 *   if (login.isPending) ...
 *   if (login.error) ...
 */
import { useMutation } from "@tanstack/react-query";
import { api } from "../api/client";
import { getCapturedAttribution } from "../lib/analytics";

export function useLogin() {
  return useMutation({
    mutationFn: async (email: string) => {
      // E57: ship this browser's first-touch utm/referrer alongside the
      // request. Auth completes in a different browser that lost the
      // params, so this is our only chance to attach paid-channel
      // attribution to the eventual Teacher + PostHog person.
      await api("/stytch/login-or-signup", {
        method: "POST",
        body: JSON.stringify({ email, attribution: getCapturedAttribution() }),
      });
    },
  });
}
